export default __webpack_public_path__ + "static/media/rust-brands.1ff45e92.svg";